import React from "react";
import { TextAreaField } from "../inputs";
import GenericFields from "./GenericFields";
import SignatureSection from "./SignatureSection";

export default function UpdateFerpa() {
  return (
    <form
      method="POST"
      action="/student-request/update-ferpa"
      onSubmit={() => {
        setSubmitting(true);
      }}
    >
      <GenericFields />

      <TextAreaField
        label="Please use the field below to describe the changes you are requesting on your FERPA Release Form. After receiving your request, you will receive a FERPA Release Form and/or a FERPA Revocation Form via email."
        name="data[ferpa_details]"
        rows={5}
        required
      />

      <SignatureSection />
    </form>
  );
}
